import React from 'react';
import PropTypes from 'prop-types';
import { connectToJSContext } from '../utils.jsx';
import { SECTION_HEADER } from '../constants';

const SectionHeader = ({
    title,
    tagline,
    urlSlug,
    buttonAttributes,
    buttonText,
    buttonLabel,
    baseLink,
    sectionId,
    switchRenderingOrder
}) => {
    return (
        <div className="container" id={sectionId}>
            <div className="row">
                <div className="col-xs-12">
                    <div className="page-header">
                        {switchRenderingOrder &&
                            <h2>
                                {title}
                            </h2>
                        }
                        {urlSlug &&
                            <a
                                className={`btn btn-lg btn-default btn-hs pull-right ${urlSlug}-page-link`}
                                aria-label={buttonLabel || buttonText || SECTION_HEADER.BUTTON_TEXT}
                                href={`${baseLink}${urlSlug}`}
                                {...buttonAttributes}
                            >
                                {buttonText || SECTION_HEADER.BUTTON_TEXT}
                            </a>
                        }
                        {!switchRenderingOrder &&
                            <h2>
                                {title}
                            </h2>
                        }
                        {tagline &&
                            <p className="tagline">{tagline}</p>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

SectionHeader.propTypes = {
    baseLink: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    tagline: PropTypes.string,
    urlSlug: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLabel: PropTypes.string,
    sectionId: PropTypes.string,
    switchOrder: PropTypes.bool
};

const mapStateToProps = state => ({
    baseLink: state.base_link
});

export default connectToJSContext(mapStateToProps)(SectionHeader);



// WEBPACK FOOTER //
// ./components/section_header/index.jsx